import { defineComponent } from '../utils/create';
import { props } from './props';
export default defineComponent({
  name: 'CbTab',
  props,
  data() {
    return {
      ancestorParent: null
    };
  },
  computed: {
    showTab() {
      return this.ancestorParent && this.ancestorParent.activeTab === this.name;
    }
  },
  watch: {
    disabled: {
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.updateTab();
        }
      },
      immediate: true
    }
  },
  created() {
    this.registerTab();
  },
  beforeDestroy() {
    this.unregisterTab();
  },
  methods: {
    findParent() {
      var parent = this.$parent;
      while (parent && parent.$options.name !== 'CbTabs') {
        parent = parent.$parent;
      }
      if (!parent) {
        return;
      }
      this.ancestorParent = parent;
    },
    registerTab() {
      this.findParent();
      if (!this.ancestorParent) {
        return;
      }
      this.ancestorParent.registerTab({
        name: this.name,
        disabled: this.disabled,
        activeBackground: this.activeBackground,
        tabHeaderStyle: this.tabHeaderStyle,
        weight: this.weight
      });
    },
    updateTab() {
      this.findParent();
      if (!this.ancestorParent) {
        return;
      }
      this.ancestorParent.updateTab({
        name: this.name,
        disabled: this.disabled
      });
    },
    unregisterTab() {
      var parent = this.$parent;
      while (parent && parent.$options.name !== 'CbTabs') {
        parent = parent.$parent;
      }
      if (!parent) {
        return;
      }
      this.ancestorParent = parent;
      parent.unregisterTab({
        name: this.name
      });
    }
  },
  render() {
    var h = arguments[0];
    return this.ancestorParent && this.ancestorParent.$props.keepChildAlive ? h("div", {
      "style": {
        display: this.showTab ? 'block' : 'none'
      }
    }, [this.$slots.default]) : this.showTab && this.$slots.default;
  }
});